import { createClient } from '@supabase/supabase-js';
import { Database } from './lib/database.types';

const supabaseUrl = import.meta.env['VITE_SUPABASE_URL'];
const supabaseKey = import.meta.env['VITE_SUPABASE_ANON_KEY'];

const supabase = createClient<Database>(supabaseUrl, supabaseKey);

type SupabaseClientType = typeof supabase;
type SubscriptionType = Database['api']['Tables']['subscription']['Row'];
type ReceiptType = Database['api']['Tables']['receipt']['Row'];
type ReceiptStoreType = Database['api']['Tables']['receipt_store']['Row'];
type ReceiptItemType = Database['api']['Tables']['receipt_item']['Row'];
type TransactionsType = Database['api']['Tables']['transaction']['Row'];
type PlaidAccountsType = Database['api']['Tables']['plaid_account']['Row'];
type PlaidItemsType = Database['api']['Tables']['plaid_item']['Row'];

function createFunctionUrl(functionName: string): string {
  let isLocalhost = false;
  if (typeof window !== 'undefined' && window.location) {
    const host = window.location.host;
    isLocalhost = host.includes('localhost') || host.includes('127.0.0.1');
  }

  if (isLocalhost) {
    return `http://localhost:54321/functions/v1/${functionName}`;
  }
  return `${supabaseUrl}/functions/v1/${functionName}`;
}

export {
  type Database,
  type SupabaseClientType,
  type SubscriptionType,
  type ReceiptType,
  type ReceiptItemType,
  type ReceiptStoreType,
  type TransactionsType,
  type PlaidAccountsType,
  type PlaidItemsType,
  supabase,
  createFunctionUrl,
};
